import type { FC } from "react";
import TextInput from "@ch/components/Inputs/TextInput";
import PhoneInput from "@ch/components/Inputs/PhoneInput";
import Checkbox from "@ch/components/Inputs/Checkbox";
import Button from "@ch/components/Buttons/Button";
import useConsentForm from "../hooks/useConsentForm";

interface Props {
  onSuccess?: () => void;
}

const ConsentForm: FC<Props> = ({ onSuccess }) => {
  const { formFieldsProps, handleConsentSubmit, canSubmit, loading } =
    useConsentForm(onSuccess);

  return (
    <form
      className="w-[600px] rounded-3xl border-2 border-[#E5E7EB] bg-white"
      onSubmit={handleConsentSubmit}
    >
      <div className="px-8 py-[30px]">
        <h2 className="text-center text-2xl font-semibold text-ink-900">
          Consent Form
        </h2>
      </div>
      <hr />
      <div className="space-y-6 px-8 py-6">
        <TextInput
          {...formFieldsProps.guardianName}
          intent="underline"
          label="Parent / Guardian Name"
          labelClassName="text-ink-900"
          leftIcon="user"
          name="guardian-name"
          placeholder="Enter full name"
          required
        />

        <PhoneInput
          {...formFieldsProps.phone}
          intent="underline"
          label="Phone Number (Whatsapp Preferred)"
          labelClassName="text-ink-900"
          name="guardian-phone"
          onCountryChange={(dialCode) =>
            formFieldsProps.countryCode.onChange(dialCode)
          }
          placeholder="Enter phone number"
          required
        />

        <TextInput
          {...formFieldsProps.email}
          intent="underline"
          label="Email"
          labelClassName="text-ink-900"
          leftIcon="envelope"
          name="guardian-email"
          placeholder="Enter email address"
          type="email"
        />

        <Checkbox
          {...formFieldsProps.agree}
          containerClassName="items-start"
          label="I confirm that I’ve submitted all my guardian / parent information correctly and agree to the Terms & Conditions"
          labelClassName="text-ink-900"
          name="guardian-agree"
        />

        <Button
          buttonStyle="w-full"
          className="btn btn-primary rounded-xl"
          disabled={!canSubmit}
          isLoading={loading}
          type="submit"
        >
          Submit
        </Button>
      </div>
    </form>
  );
};

export default ConsentForm;
